var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 16C1.25 17.7125 2.6375 19.1125 4.3625 19.1125C6.075 19.1125 7.475 17.725 7.475 16C7.475 14.2875 6.0875 12.8875 4.3625 12.8875C2.6375 12.8875 1.25 14.2875 1.25 16Z",
    fill: "#22A873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8875 16C12.8875 17.7125 14.275 19.1125 16 19.1125C17.7125 19.1125 19.1125 17.725 19.1125 16C19.1125 14.2875 17.725 12.8875 16 12.8875C14.2875 12.8875 12.8875 14.2875 12.8875 16Z",
    fill: "#22A873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5376 16C24.5376 17.7125 25.9251 19.1125 27.6501 19.1125C29.3626 19.1125 30.7626 17.725 30.7626 16C30.7626 14.2875 29.3751 12.8875 27.6501 12.8875C25.9251 12.8875 24.5376 14.2875 24.5376 16Z",
    fill: "#22A873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGreen);
export default __webpack_public_path__ + "static/media/dots-green.6223dc6ae03ee29b0311b61491b82270.svg";
export { ForwardRef as ReactComponent };